// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";  // ✅ Add this

const firebaseConfig = {
  apiKey: "AIzaSyB3YLoZLYlTQBukZCpDRJzMbmuNqQk46OU",
  authDomain: "kamliyasoft-83920.firebaseapp.com",
  projectId: "kamliyasoft-83920",
  storageBucket: "kamliyasoft-83920.appspot.com",
  messagingSenderId: "525878003215",
  appId: "1:525878003215:web:85c3a8cd6b42ee37d0457a",
  measurementId: "G-T16VXT56SY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Firestore
export const db = getFirestore(app);

// ✅ Storage (for file uploads)
export const storage = getStorage(app);
